import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export type QueryProviderProps = {
  children: React.ReactNode;
};

/**
 * QueryProvider
 *
 * Wraps the app with a shared TanStack QueryClient (CSR-only).
 * Defaults are conservative to avoid noisy refetches in the MVP.
 */
function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: true,
        refetchOnMount: "always",
        retry: 1,
        staleTime: 0,
        gcTime: 0,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}

export function QueryProvider({ children }: QueryProviderProps) {
  const [client] = React.useState(() => createQueryClient());

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
}
